export const tableBalances = [
    {label: "Produto", index: "produto", isSelected: true},
    {label: "Endereço", index: "endereco", isSelected: true},
    {label: "Armazem", index: "armazem", isSelected: true},
    {label: "Empresa", index: "empresa", isSelected: true},
    {label: "Lote", index: "lote", isSelected: true},
    {label: "Cliente", index: "cliente", isSelected: true},
    {label: "Etiqueta Palete", index: "etiqueta_palete", isSelected: true},
    {label: "Unidade Medida", index: "unidade_medida", isSelected: true},
    {label: "Saldo", index: "saldo", isSelected: true},
    {label: "Saldo Reservado", index: "saldo_reservado", isSelected: true},
];